import client from '../config/axios';

export const getAllLocales = async () => {
    const response = await client.get("/locale");
    return response.data;
  }
  